Vue.component('datatable', {
    props: {
        tableCols: {
            type: Object,            
        },
        tableRows: {
            type: Object,            
        },
        isLoading: {
            type: Boolean
        },
        tableColsKey: {
            type: String
        },
        tableRowKey: {
            type: String
        },
        tableKeyedObject: {
            type: Object
        },
        selectedData: {
            type: Object
        },
        featured: {
            type: Array
        }

    },
    data () {
        return {
            currentSort: 0,
            currentSortDir:'asc'
        }

    },
    computed: {
        sortedRows () {            
            let self = this;
            let order = [];
            let thiskey = 'agency_name';
            let isNumeric = false;
            if (self.tableCols[self.currentSort] && self.tableCols[self.currentSort].data_type && (self.tableCols[self.currentSort].data_type == "Number" || self.tableCols[self.currentSort].data_type == "Calculation")) {
                isNumeric = true;
            }
            if (self.currentSort == 0) {
                order = Object.keys(self.tableKeyedObject).sort( function (keyA, keyB) {
                    if(self.currentSortDir === 'desc') { 
                        if(self.tableKeyedObject[keyB].agency_name > self.tableKeyedObject[keyA].agency_name) { return 1; }
                        else {return -1;}                        
                    }
                    if(self.tableKeyedObject[keyB].agency_name > self.tableKeyedObject[keyA].agency_name) { return -1; }
                    else {return 1;}
                })
            }
            else {
                order = Object.keys(self.tableRows).sort( function(keyA, keyB) {                                                    
                    if (isNumeric) {
                        let thisA = self.tableRows[keyA][self.currentSort];
                        let thisB = self.tableRows[keyB][self.currentSort];
                        
                        if (thisA == "NaN" || thisA == "INF") {thisA = -1;}
                        if (thisB == "NaN" || thisB == "INF") {thisB = -1;}

                        if(self.currentSortDir === 'desc') { return thisB - thisA}
                        return thisA - thisB;    
                    }
                    if(self.currentSortDir === 'desc') {
                        if (self.tableRows[keyA][self.currentSort] > self.tableRows[keyB][self.currentSort]) {return 1;}
                        else {return -1;}                          
                    }
                    if (self.tableRows[keyA][self.currentSort] > self.tableRows[keyB][self.currentSort]) {return -1;}
                    else {return 1;}  
                });
            }            
            let newObj = {};
            order.forEach(item => {
                newObj["'" + item + "'"] = this.tableRows[item];
            }); 
            return newObj;  
        },
        noData () {
            if (this.sortedRows && Object.keys(this.sortedRows).length > 0) {return false;}
            return true;
        },
        allVals () {
            if (!this.tableRows) {return false;}
            let $this = this;
            let vals = {};
            Object.keys(this.tableRows).forEach(function(key) {
                Object.keys($this.tableRows[key]).forEach(function(key2) {
                    if (!vals[key2]) {vals[key2] = [];}
                    vals[key2].push($this.tableRows[key][key2]);
                })
                
            })
            return vals;
        },
        showSummary () {
            if (Object.keys(this.tableRows).length > 1) {
                return true;
            }
            return false;
        }
    },
    mounted () {
        
    },
    methods: { 
        getCellData (r, c, j, i) {        
            
            // FOR AGENCY
            if (c[this.tableColsKey] == 0) {
                // remove single quote that made string        

                j = j.replace(/'/g,'');
                if (this.tableRowKey == "state") {
                    
                    let abbr = j;
                    if (j.length > 3) {
                        let abbrs = slideStateToAbbr();
                        abbr = abbrs[slideTitleCase(j)];
                    }
                    
                    return '<a href="https://libslide.org/data-tools/state-profile/?saved=' + abbr + '&type=stateprofile">' + j + '</a>';
                }
                if (this.tableKeyedObject[j]) {
                    
                    let thisNCES = this.tableKeyedObject[j].nces_id;
                    
                    return '<a href="/profile?nces_id=' + thisNCES + '">' + this.tableKeyedObject[j].agency_name + ' (' + this.tableKeyedObject[j].StAbr + ')</a>';
                }
                return ''                
            }
            if (!r) {return 'N/A';}
            let field = this.selectedData.selected.filters[this.tableColsKey].filter(item => item[this.tableColsKey] == c[this.tableColsKey]);
            
            if (field[0] && field[0].data_format) {                
                return formatSlideData(r[i], field[0].data_format, field[0]);                
            }           
            return r[i];
        },
        getColumnName (c,i) {
            if (i.indexOf("_") > -1) {
                let split = i.split("_");
                return c.data_name + " (" + split[1] + ")";
            }
            return c.data_name;
        },
        isActive (c) {
            return c == this.currentSort;
            
        },
        updateSort (s) {
            let triangle = document.getElementById('triangle-'+s);
            if (s === this.currentSort) {
                this.currentSortDir = this.currentSortDir==='asc'?'desc':'asc';
                if (this.currentSortDir == 'desc') {triangle.classList.add('down');}
                else {triangle.classList.remove('down');}
            }
            else {
                this.currentSortDir = 'asc';
                triangle.classList.remove('down');
            
            }
            this.currentSort = s
        },
        stripHTML (html) {
            let doc = new DOMParser().parseFromString(html, 'text/html');
            return doc.body.textContent || "";
            
        },
        exportCSV () {
            
            let arrayHeader = [];
            let $this = this;
            for (c in this.tableCols) {
                d = this.getColumnName(this.tableCols[c], c)            
                arrayHeader.push(d);
            }

            let arrayData = [];
            
            for (r in this.sortedRows) {
                /* FIRST REMOVE EXTRA STRINGS THAT COME IN PLACE DUE TO EARLIER FORMATTING */
                if (r.length && r[0] === "'") {
                    r = r.substring(1);
                }
                if (r.length && r.charAt(r.length-1) == "'") {
                    r = r.slice(0, -1);
                }
                
                let rowData = [];
                for (c in this.tableCols) {
                    /*
                    if (i.indexOf("_") > -1) {
                        let split = i.split("_");
                        return c.data_name + " (" + split[1] + ")";
                    }
                    return c.data_name;
                    */
                    
                    let d = this.stripHTML(this.getCellData($this.tableRows[r], this.tableCols[c], r, c)).replace(/,/g, '');    
                    rowData.push(d.replace(",", ''));                        
                    
                }     
                arrayData.push(rowData);         
            }
            if (this.showSummary) {
                rowData = [];
                for (c in this.tableCols) {
                    
                    let d = this.getMedian(this.tableCols[c], c).toString(); 
                    
                    rowData.push(d.replace(",", ''));
                }     
                arrayData.push(rowData);   
                rowData = [];
                for (c in this.tableCols) {
                    
                    let d = this.getMean(this.tableCols[c], c).toString();     
     
                    rowData.push(d.replace(",", ''));
                }     
                arrayData.push(rowData);  
            }
            
            let delimiter = ",";
            let fileName = "SLIDE_Data_File";
            let header = arrayHeader.join(delimiter) + '\n';
            let csv = header;
            arrayData.forEach( array => {
                csv += array.join(delimiter)+"\n";
            });
            
            let csvData = new Blob([csv], { type: 'text/csv' });  
            let csvUrl = URL.createObjectURL(csvData);
    
            let hiddenElement = document.createElement('a');
            hiddenElement.href = csvUrl;
            hiddenElement.target = '_blank';
            hiddenElement.download = fileName + '.csv';
            hiddenElement.click();
            bus.$emit("tutorialListener", "csvdownloaded")      
        },        
        isFeatured (item) {
            // remove single quotes that were necessary in sorting
            item = item.replace(/\'/g, "") 
            if (this.featured.includes(item)) {                
                return true;
            }
            return false;
        },
        getMedian (c, i) {
            let $this = this;
            if (i == 0 || i == 'c0') {return "Median";}
            if (this.tableCols[i].data_format == "Text") {return "N/A";}
            if ($this.allVals[i]) {                
                let s = 0;
                let newvals = [];
                // loop through to ignore any NaNs
                $this.allVals[i].forEach(function (v)  {
                    let val = parseFloat(v);                    
                    if (Number.isNaN(val) || val == -1) {return;}
                    newvals.push(val);                    
                })
                const mid = Math.floor(newvals.length / 2),
                nums = [...newvals].sort((a, b) => a - b);
                let r = newvals.length % 2 !== 0 ? nums[mid] : (nums[mid - 1] + nums[mid]) / 2;
                return formatSlideData(r, $this.tableCols[i].data_format)
            }            
            return 'N/A';
        },
        getMean (c, i) {
            if (i == 0 || i == 'c0') {return "Average";}
            if (this.tableCols[i].data_format == "Text") {return "N/A";}
            let $this = this;
            if ($this.allVals[i]) {     
                let num = 0;
                let sum = 0;
                // loop through to ignore any NaNs
                $this.allVals[i].forEach(function (v)  {
                    let val = parseFloat(v);                    
                    if (Number.isNaN(val) || val == -1) {return;}
                    num++;
                    sum += val;                  
                })
                let avg = sum / num;
                return formatSlideData(avg, $this.tableCols[i].data_format);
                
            }            
            return 'N/A';
        }
    }
})